import { RENDER_EFFECT } from '../../common/constants';
export const isRenderEffects = (t) => {
    if (typeof t !== 'string') {
        return false;
    }
    return Object.values(RENDER_EFFECT).some(effect => effect === t);
};
